module.exports = __webpack_public_path__ + "static/media/blogster.f8ca0bb7.svg";